import React from 'react'
import CardUI from '../../../widgets/layout/CardUI'
import './NetCashFlow.css'

const NetCashFlowUI = ({ context, account, netCashFlowList }) =>
    <CardUI className='g_m_top_100 g_m_bottom_200 c_ncf'
        title='Net Cash Flow as per Bank'>
        {
            (!netCashFlowList || netCashFlowList.length === 0) &&
            <div className='g_m_top_100 g_text_center g_muted'>No data available</div>
        }
        {
            netCashFlowList && netCashFlowList.length > 0 &&
            <table>
                <thead className='g_sticky'>
                    <tr>
                        <th className='g_text_left'>Month</th>
                        <th className='g_text_right'>Revenue</th>
                        <th className='g_text_right'>Direct Expenses</th>
                        <th className='g_text_right'>EMI</th>
                        <th className='g_text_right'>Salary</th>
                        <th className='g_text_right'>Other Expenses</th>
                        <th className='g_text_right'><b>Net Cash Flow</b></th>
                    </tr>
                </thead>
                <tbody>
                    {
                        netCashFlowList.map((monthlyData, i) =>
                            <RowUI key={i} monthlyData={monthlyData} />
                        )
                    }
                </tbody>
            </table>
        }
    </CardUI>

const RowUI = ({ monthlyData }) =>
    <tr>
        <td className='g_text_left g_no_wrap_2'>{monthlyData.month}</td>
        <td className='g_text_right'>{monthlyData.revenue}</td>
        <td className='g_text_right'>{monthlyData.directExpenses}</td>
        <td className='g_text_right'>{monthlyData.emi}</td>
        <td className='g_text_right'>{monthlyData.salary}</td>
        <td className='g_text_right'>{monthlyData.otherExpenses}</td>
        <td className={`g_text_right ${monthlyData.netCashFlow.includes('(') ? 'g_error' : 'g_success'}`}>
            <b>{monthlyData.netCashFlow}</b>
        </td>
    </tr>

export default NetCashFlowUI
